import {getBannerArea} from '@web/slices/banner/slice'
import makeSlice from '@web/slices/banner/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const bannerSlice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload: {banner, products}}) => {
            state.bannerArea = getBannerArea(banner.bannerListsByExposureAreaType)
            state.expectedTotalRewardPointBySubscribing = banner.expectTotalRewardPointBySubscribing ?? 0
            state.expectedTotalRewardPointOfTodayOrders = banner.expectTotalRewardPointOfTodayOrders ?? 0
            state.plccExpectedPercentage = banner.plccExpectedPercentage
            state.plccMaximumAmount = banner.plccMaximumAmount
            state.userName = banner.userName
            state.naverBenefit = products.some(({naverBenefit}) => naverBenefit)
        })
    },
})

export default bannerSlice.reducer

export const actions = bannerSlice.actions
